var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yiyuan",attrs:{"id":"home"}},[_c('router-view'),_vm._v(" "),_c('el-carousel',{attrs:{"interval":5000,"arrow":"never"}},[_c('el-carousel-item',[_c('div',{staticClass:"background1"},[_c('div',{staticClass:"box"})])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8742f076","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home.vue
// module id = null
// module chunks = 